import React from 'react'

function HorizontalComponent() {
    return (
        <div>
            <div className='horizontal '>
                <div className='text-center mainComponentCenter d-flex flex-column justify-content-center align-items-center'>
                    <h2 className='bookFont text-light mt-5 text-center'>
                        "ELEVATE YOUR BEAUTY, EMBRACE MEHANDI"
                    </h2>
                    <p className='nav-item-main-subhead-footer text-light mt-lg-4'>
                        Timeless Artistry for Your Every Occasion
                    </p>
                </div>
            </div>
        </div>
    )
}

export default HorizontalComponent
